import { render } from "./AVB.vue?vue&type=template&id=506fa5ee&scoped=true"
import script from "./AVB.vue?vue&type=script&lang=js"
export * from "./AVB.vue?vue&type=script&lang=js"

import "./AVB.vue?vue&type=style&index=0&id=506fa5ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_typescript@5.6.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506fa5ee"]])

export default __exports__